import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { noOp } from '../../helpers'

const ContentsSwitcher = ({
  children,
  contents,
  currentContentIndex,
  className,
  contentKey,
}) =>
  contents.map((content, index) => (
    <div
      className={`content-switcher ${className}`}
      key={contentKey ? content[contentKey] : index}
      style={{
        position: 'fixed',
        visibility: `${currentContentIndex === index ? 'visible' : 'hidden'}`,
        opacity: `${currentContentIndex === index ? '1' : '0'}`,
      }}
    >
      {useMemo(() => children(content), [children])}
    </div>
  ))

ContentsSwitcher.propTypes = {
  children: PropTypes.func,
  contents: PropTypes.array,
  currentContentIndex: PropTypes.number,
  className: PropTypes.string,
  contentKey: PropTypes.string,
}

ContentsSwitcher.defaultProps = {
  children: noOp,
  contents: [],
  currentContentIndex: 0,
  className: '',
}

export default ContentsSwitcher
